<template>
  <section class="container">
    <l-map ref="mapa" :style="{ 'height': configuracionExterna.mapaAltura, 'z-index': 1 }" :bounds="bounds" :zoom="zoom"
      :center="center" @click="onClickMap">
      <l-control-fullscreen position="topleft" @click="onClickFull"
        :options="{ title: { 'false': 'Pantalla completa', 'true': 'Normal' } }" />
      <l-tile-layer :url="urlMapa" :attribution="atribucion"></l-tile-layer>

      <template v-if="configuracionExterna.showCluster && !this.conDestacado">
        <vue-marker-cluster>
          <marcador :inmueble="inmueble" v-for="(inmueble, index) in inmuebles" :key="index"></marcador>
        </vue-marker-cluster>
      </template>
      <template v-else>
        <marcador :inmueble="inmueble" v-for="(inmueble, index) in inmuebles" :key="index" @click="onClickMarcador">
        </marcador>
      </template>
    </l-map>
  </section>
</template>

<script lang="ts">
import { Inmueble } from '@/Modelos/Inmueble';
import { Component, Vue, Watch,Ref } from 'vue-property-decorator';
import { LMap, LTileLayer } from 'vue2-leaflet';
import { latLngBounds, LatLngBounds, LatLngExpression } from 'leaflet';
import { namespace } from "vuex-class";
import Marcador from './Marcador/Marcador.vue';
import { ConfiguracionExterna } from '@/Modelos/ConfiguracionExterna';
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import LControlFullscreen from 'vue2-leaflet-fullscreen';

const WidgetMapStore = namespace('WidgetMapStore');

@Component({
  components: {
    LMap,
    LTileLayer,
    Marcador,
    'vue-marker-cluster': Vue2LeafletMarkerCluster,
    LControlFullscreen
  }
})
export default class Mapa extends Vue {

  @WidgetMapStore.State
  private inmuebles!: Array<Inmueble>;

  @WidgetMapStore.State('configuracionExterna')
  configuracionExterna!: ConfiguracionExterna;
  

  private urlMapa = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
  private atribucion = '<a target="_blank" href="https://visualinmueble.com/"> Software para Inmobiliarios</a>';
  private zoom = 6;
  private center: LatLngExpression = [4.570868, -74.297333];
  private latitudes: Array<LatLngExpression> = [];
  private bounds: LatLngBounds | null = null;
  private conDestacado = false;

  @Ref("mapa") readonly mapa!: LMap;

  constructor() {
    super();
    this.zoom = 15;
  }

  private destacarInmueble(inmueble: Inmueble) {
    this.center = [inmueble.latitud, inmueble.longitud];
    this.latitudes = [[inmueble.latitud, inmueble.longitud]];
  }

  @Watch('inmuebles')
  onChangeInmuebles(newV: Array<Inmueble>) {
    if (newV) {
      newV.forEach((inmueble: Inmueble) => {
        this.latitudes.push([inmueble.latitud, inmueble.longitud]);
        if (inmueble.destacado) {
          this.destacarInmueble(inmueble);
          this.conDestacado = true;
          this.zoom = 16;
          return;
        }
      });
      if (!this.conDestacado) {
        this.bounds = latLngBounds(this.latitudes);
      }
    } else {
      this.bounds = latLngBounds([]);
    }
  }

  mounted() {
    // Asegúrate de que el mapa se pinte de manera correcta
    setTimeout(() => {
      this.adjustMapSize();
    }, 250);

    // Escuchar el evento de resize
    window.addEventListener('resize', this.onResize);
  } 


  beforeDestroy() {
    // Eliminar el listener al destruir el componente
    window.removeEventListener('resize', this.onResize);
  }

  onClickMarcador() {
    this.$store.dispatch("AnalyticsStore/logEvent", {
      name: 'select_content',
      data: {
        screen_name: 'Mapa Inmu',
        content_type: 'property',
        items: this.inmuebles.map((inmueble: Inmueble) => {
          return {
            id: inmueble.codigo,
            name: inmueble.nombre,
            price: inmueble.valor_canon,
            category: inmueble.tipo_inmueble.nombre + " / " + inmueble.gestion.nombre
          }
        })
      }
    });
  }

  onClickMap() {
    this.$store.dispatch("AnalyticsStore/logEvent", {
      name: 'map_click',
      data: {}
    });
  }

  onClickFull() {
    alert("ok");
  }

  public adjustMapSize() {
    // Asegurarse de que el mapa esté disponible
    if (this.mapa) {
      // Invalidar el tamaño del mapa
      this.mapa.mapObject.invalidateSize();

      
      // Ajustar bounds o zoom si es necesario
      this.$nextTick(() => {
        if (this.bounds) {
          this.mapa.mapObject.fitBounds(this.bounds);
        } else {
          this.mapa.mapObject.setView(this.center, this.zoom);
        }
      });
      
    }
  }

  private onResize() {
    this.adjustMapSize();
  }
}
</script>

<style lang="scss" scoped>
@import '~leaflet/dist/leaflet.css';
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
@import "~leaflet-fullscreen/dist/leaflet.fullscreen.css";

::v-deep .leaflet-pane {
  z-index: 50 !important;
}

::v-deep .leaflet-control-container {
  .leaflet-top {
    z-index: 51 !important;
  }
}
</style>
